// @core/api/endpoints/billing/get_invoice.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetInvoiceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get invoice by ID
 * Retrieves an invoice by its unique identifier. Returns the complete invoice with all line items, discounts, taxes, and payment status.
 */
export async function GetInvoice(
  id: string,
  options?: RequestOptions
): Promise<GetInvoiceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/invoices/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetInvoiceResponse>(requestPath, { ...requestOptions });
}
